export default {"src":"/_next/static/media/spinner.7ea7cd0d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};